import './timeseries_chart_view.js.coffee'

Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.HistogramByTaxonomyView extends Monitoring.Views.Charts.TimeseriesChartView
  hierarchySelectingTemplate: JST["backbone/templates/monitoring/hierarchy_select"]
  template_path: JST['backbone/templates/monitoring/charts/tree_path']
  valueField: 'count'
  chartOptions: {
    yAxis:
      min: 0
    plotOptions:
      spline:
        marker:
          enabled: false
  }

  events:
    'click #change_hierarchy': 'onClickChangeHierarchy'
    'click .taxonomyChoise': 'changeTaxonomy'
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'


  initialize: (@options = {}) ->
    @title = I18n.t('monitoring.dashboard.charts.ugc_per_node')
    @title_en = I18n.t('monitoring.dashboard.charts.ugc_per_node', {'locale': 'en'})
    @path = @options.settings.path || []
    super(@options)
    @inClickWindowTime = false
    @searchQuery = @options.searchQuery
    @_settings = @options.settings
    @_settings.maximized = !!@_settings.maximized
    @container = @options.container
    @tags_limit = 10
    @_settings['reduced_tree'] = true
    @name = 'histogram_by_taxonomy'
    @_settings.currentTaxonomyCode = @_settings.currentTaxonomyCode || 'Default'
    @taxonomiesRepository = new Monitoring.Models.TaxonomiesRepository
    if @searchQuery.get('labels').length > 0
      @facets.label.terms = _.filter(@facets.label.terms, (term) => @searchQuery.get('labels').indexOf(term.term) != -1)

  _dataIsEmpty: ->
     @hierarchyNavigator.data.length == 0


  addSeries: ->
    @series = []
    @singularSeries = []
    @accumulatedSeries = []
    @accumulated = false
    query = @searchQuery.deepCopy()
    query.set('taxonomy_code',  @_settings.currentTaxonomyCode)
    query.set('interval', @intervalParam)
    @ajaxCall("/monitoring/dashboard/charts/histogram_by_taxonomy/", query.toJSON(), (response) =>
      _.each(response.values, (value) =>
        @addSerie(value.node_name, value.histogram, response.values.length)
      )
      @date_from_realtime = response.date_from_realtime if response.date_from_realtime
      @date_to_realtime = response.date_to_realtime if response.date_to_realtime
    )
    @

  getNewQuery: (event) ->
    query = super(event)
    query.set('tags_node_name_level', 1)
    query.set('tags_node_name', [event.point.series.name])
    query.set('taxonomy_code',  @_settings.currentTaxonomyCode)
    return query

  afterAppend: ->
    if @hierarchyNavigator
      @data = @hierarchyNavigator.extractData()
      @_settings.path = @path
      @trigger('chartsChange')
      @addSeries()
      @afterAppendHTML()
    else
      @taxonomiesRepository.loadAlternativeTaxonomies(() =>
        @$el.find('#close_chart').before(@hierarchySelectingTemplate(
          includeAlternativeTaxonomies: Keepcon.currentAccount.includeAlternativeTaxonomies,
          taxonomiesRepository: @taxonomiesRepository
        ))
        query = @searchQuery.toJSON()
        query.taxonomy_code = @_settings.currentTaxonomyCode
        @ajaxCall('/monitoring/dashboard/charts/hierarchy', query, (response) =>
          @hierarchyNavigator = new Monitoring.Views.Charts.HierarchyNavigator(@path, response, {
            ordered: true,
            tags_limit: 10,
            show_limited: true
          })
          @data = @hierarchyNavigator.extractData()
          @addSeries()
          @afterAppendHTML()
        )
      )
    return this

  onClickChangeHierarchy: (evt) ->
    @$el.find('#change_hierarchy_menu').toggleClass('taxonomy_dropdown_show')

  changeTaxonomy: (evt) ->
    @$el.addClass('processing')
    @$el.find('.chart').html('')
    chosenTaxonomyName = $(evt.target).text()
    @$el.find('#change_hierarchy_menu').toggleClass('taxonomy_dropdown_show')
    taxonomy = @taxonomiesRepository.taxonomyWithName(chosenTaxonomyName)
    @_settings.currentTaxonomyCode = taxonomy.get('code')
    query = @searchQuery.deepCopy()
    query.set('taxonomy_code', @_settings.currentTaxonomyCode)
    @ajaxCall('/monitoring/dashboard/charts/hierarchy', query.toJSON(), (response) =>
      @hierarchyNavigator = new Monitoring.Views.Charts.HierarchyNavigator(@path, response, {
        ordered: true,
        tags_limit: 10,
        show_limited: true
      })
      unless @hierarchyNavigator.existsPathInTree()
        @path = @options.settings.path || []
        @hierarchyNavigator.onSubpath('')
      @addSeries()
    )


  _path: ->
    if @hierarchyNavigator then @hierarchyNavigator.path else @path


  afterAppendHTML: ->
    $(this.el).find("#path").html(@template_path(tree_path: @_path()))
    @$el.removeClass('processing')
    @trigger('masonry')

  addExtraMenuItems: =>
    extraItems = []
    extraItems.concat( @taxonomiesRepository.loadCurrentTaxonomies(() =>
      @$el.find('#close_chart').before(@hierarchySelectingTemplate(
        includeAlternativeTaxonomies:true,
        taxonomiesRepository: @taxonomiesRepository
      ))))
